'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../index.mjs";

/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconNewspaper/index.tsx)
 */
export function IconNewspaper(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M.296.691A.75.75 0 0 1 1.044 0H12.25a.75.75 0 0 1 .75.75V2h2.25a.75.75 0 0 1 .75.75v9.684a19.946 19.946 0 0 1-.05 1.404c-.03.379-.08.8-.17 1.142a1.962 1.962 0 0 1-.219.542c-.1.16-.356.478-.811.478H2.12c-.754 0-1.163-.62-1.365-1.061-.225-.493-.375-1.142-.48-1.843C.06 11.68-.005 9.82 0 7.998c.004-1.83.078-3.656.151-5.022A115.118 115.118 0 0 1 .284.858L.293.734.296.691zm1.446.809c-.026.388-.06.922-.093 1.556A99.954 99.954 0 0 0 1.5 8.002c-.004 1.803.062 3.57.258 4.87.099.659.224 1.143.361 1.443.044.095.078.152.102.185h9.715c-.34-.657-.436-1.437-.436-2.192V1.5H1.742zm12.616 12.978a6.57 6.57 0 0 0 .096-.758 16.27 16.27 0 0 0 .046-1.374V3.5H13v8.808c0 .796.13 1.336.368 1.666.166.23.443.438.99.504zM10 5H3V3.5h7V5zm0 3.75H3v-1.5h7v1.5zm0 3.75H3V11h7v1.5z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M1.503 1.925A1 1 0 0 1 2.5 1H19a1 1 0 0 1 1 1v3h3a1 1 0 0 1 1 1v11.066l-.003.17a20.9 20.9 0 0 1-.196 2.412c-.098.653-.254 1.386-.522 1.981-.234.52-.758 1.371-1.779 1.371H4c-1.02 0-1.569-.852-1.838-1.449-.303-.673-.506-1.562-.65-2.528-.294-1.95-.387-4.511-.387-7.023 0-2.523.095-5.04.189-6.925a161.988 161.988 0 0 1 .172-2.92l.012-.17.005-.06zM3.434 3c-.034.538-.078 1.286-.123 2.175A140.726 140.726 0 0 0 3.125 12c0 2.489.094 4.928.364 6.727.136.91.308 1.582.497 2.003.064.141.114.224.147.27h14.662a7.014 7.014 0 0 1-.378-1.041C18.047 18.649 18 17.297 18 17V3H3.434zm17.93 17.986c.023-.039.054-.096.091-.178.154-.342.279-.86.369-1.456.087-.581.131-1.17.154-1.62a19.13 19.13 0 0 0 .022-.686V7h-2v10c0 .203.042 1.352.342 2.416.15.535.345.968.569 1.249.157.197.3.29.452.321zM16 9H5V7h11v2zm0 4H5v-2h11v2zm0 4H5v-2h11v2z\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconNewspaper is deprecated and will be archived soon. Use IconNewspaper instead.
 */
export function Experimental__IconNewspaper(props) {
  return /*#__PURE__*/React.createElement(IconNewspaper, props);
}